import React from 'react';
import { toast } from 'react-toastify';

import Sidebar from '../layouts/Sidebar';
import Button from '../components/ui/Button';

export default function Settings() {
  return (
    <Sidebar title="Settings">
      <section className="space-y-6">
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <div className="xl:col-span-2 bg-white rounded-xl border border-neutral-200 shadow-subtle p-8">
            <h3 className="font-bold text-lg text-neutral-900 mb-6">System Configuration</h3>
            <div className="space-y-5">
              <div>
                <label className="form-label" htmlFor="settings-system-name">System Name</label>
                <input
                  id="settings-system-name"
                  className="form-input"
                  defaultValue="SEHA CBRNE & Disaster Command Platform"
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="form-label" htmlFor="settings-timezone">Timezone</label>
                  <select id="settings-timezone" className="form-input">
                    <option>Gulf Standard Time (GST)</option>
                    <option>UTC</option>
                  </select>
                </div>
                <div>
                  <label className="form-label" htmlFor="settings-language">Default Language</label>
                  <select id="settings-language" className="form-input">
                    <option>English</option>
                    <option>Arabic</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="form-label" htmlFor="settings-maps-key">Google Maps JavaScript API Key</label>
                <input id="settings-maps-key" className="form-input" defaultValue="YOUR_API_KEY" />
              </div>
              <Button size="lg" onClick={() => toast.success('Settings saved for review.')}>
                Save Settings
              </Button>
            </div>
          </div>
          <div className="bg-white rounded-xl border border-neutral-200 shadow-subtle p-6">
            <h3 className="font-bold text-neutral-800 mb-4">Deployment Notes</h3>
            <div className="space-y-3 text-sm text-neutral-600 leading-relaxed">
              <p>Replace <b>YOUR_API_KEY</b> with a valid Google Maps JavaScript API key.</p>
              <p>Production must enforce server-side RBAC, MFA, encrypted API calls, device binding and immutable audit logs.</p>
              <p>Connect staff mobile app, patient tablet app, HIS/HL7/FHIR, sensor gateway and communication gateway.</p>
            </div>
          </div>
        </div>
      </section>
    </Sidebar>
  );
}
